"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Event = _interopRequireDefault(require("../../darkmatter/Event"));
function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var EventButton = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(EventButton, _React$Component);
  var _super = _createSuper(EventButton);
  function EventButton() {
    (0, _classCallCheck2["default"])(this, EventButton);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(EventButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        event = _this$props.event,
        children = _this$props.children,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, ["event", "children"]);
      return /*#__PURE__*/_react["default"].createElement(_Event["default"], {
        event: event,
        eventType: "click"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, rest, children));
    }
  }]);
  return EventButton;
}(_react["default"].Component);
exports["default"] = EventButton;
EventButton.propTypes = {
  event: _propTypes["default"].shape({
    category: _propTypes["default"].string.isRequired,
    action: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string,
    value: _propTypes["default"].number,
    nonInteraction: _propTypes["default"].bool
  }).isRequired
};